// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_bulkUploadNavButton__hb7wC {
  width: 250px;
  font-size: 14px !important;
  margin-top: 30px !important;
  color: white !important;
  background-color: #00ab55 !important;
  text-transform: none !important;
  font-family: "Montserrat" !important;
  font-size: 15px !important;
  font-weight: 700 !important ;
  line-height: 26px !important ;
  letter-spacing: 0px !important;
  /* text-align: left !important; */
}
.Home_addNewFpoBtn__oDyIW {
  /* background-color: aliceblue !important; */
  width: 250px;
  font-size: 14px !important;
  font-weight: 600 !important;
  /* color: black !important; */
}
.Home_textField__uMnuD {
  margin: 15px 0px !important;
  font-family: "Montserrat" !important;
  max-width: 544px !important;
  width: 100% !important;
}
.Home_titleHead__r-5FZ {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  color: #3d4a52 !important;
  margin: 30px 0px !important;
  width: max-content !important;
}
.Home_subHead__ymla\\+ {
  font-family: "Montserrat" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 24.38px !important;
  color: #000000 !important;
  margin-top: 30px !important;
  width: max-content !important;
}
.Home_css-nftsw0-MuiButtonBase-root-MuiTab-root__M8DpN.Home_Mui-selecte__OcW1p {
  font-family: "Montserrat" !important;
  color: #00ab55 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
}
.Home_SelectFpo__H0H0n {
  font-family: "Montserrat" !important;
  color: #8f8f8f !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
  margin: 50px 50px 100px 50px !important;
  text-align: center;
}
.Home_programOfficer__CmqQF {
  color: #8f8f8f !important;
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 400 !important;
  line-height: 40px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
}
.Home_lastUpdate__nqZ6D {
  background: #d6f4f9 !important;
  color: #006c9c !important;
  border: 1px solid #d6f4f9 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  /* width: 524px !important; */
  font-family: "Montserrat" !important;
  font-weight: 400 !important;
  margin-top: 40px !important;
  margin-bottom: 30px !important;
  height: 44px !important;
  line-height: 20px !important;
  padding: 10px !important;
  gap: 10px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  /* align-items: center !important; */
}
.Home_buttonStyle__eGXze {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
  margin-left: auto !important;
}
.Home_boxStyle__t1-P4 {
  width: 1108px !important;
  height: 48px !important;
  padding: 0px 24px 0px 0px !important;
  gap: 50px !important;
  border: 0px 0px 1px 0px !important;
  opacity: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,4CAA4C;EAC5C,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,sCAAiC;EAAjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;AACzB","sourcesContent":[".bulkUploadNavButton {\n  width: 250px;\n  font-size: 14px !important;\n  margin-top: 30px !important;\n  color: white !important;\n  background-color: #00ab55 !important;\n  text-transform: none !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 15px !important;\n  font-weight: 700 !important ;\n  line-height: 26px !important ;\n  letter-spacing: 0px !important;\n  /* text-align: left !important; */\n}\n.addNewFpoBtn {\n  /* background-color: aliceblue !important; */\n  width: 250px;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  /* color: black !important; */\n}\n.textField {\n  margin: 15px 0px !important;\n  font-family: \"Montserrat\" !important;\n  max-width: 544px !important;\n  width: 100% !important;\n}\n.titleHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  color: #3d4a52 !important;\n  margin: 30px 0px !important;\n  width: max-content !important;\n}\n.subHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 24.38px !important;\n  color: #000000 !important;\n  margin-top: 30px !important;\n  width: max-content !important;\n}\n.css-nftsw0-MuiButtonBase-root-MuiTab-root.Mui-selecte {\n  font-family: \"Montserrat\" !important;\n  color: #00ab55 !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 22px !important;\n  letter-spacing: 0px !important;\n}\n.SelectFpo {\n  font-family: \"Montserrat\" !important;\n  color: #8f8f8f !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 22px !important;\n  letter-spacing: 0px !important;\n  margin: 50px 50px 100px 50px !important;\n  text-align: center;\n}\n.programOfficer {\n  color: #8f8f8f !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 400 !important;\n  line-height: 40px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n}\n.lastUpdate {\n  background: #d6f4f9 !important;\n  color: #006c9c !important;\n  border: 1px solid #d6f4f9 !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  /* width: 524px !important; */\n  font-family: \"Montserrat\" !important;\n  font-weight: 400 !important;\n  margin-top: 40px !important;\n  margin-bottom: 30px !important;\n  height: 44px !important;\n  line-height: 20px !important;\n  padding: 10px !important;\n  gap: 10px !important;\n  overflow: hidden !important;\n  white-space: nowrap !important;\n  text-overflow: ellipsis !important;\n  /* align-items: center !important; */\n}\n.buttonStyle {\n  max-width: fit-content !important;\n  margin-left: auto !important;\n}\n.boxStyle {\n  width: 1108px !important;\n  height: 48px !important;\n  padding: 0px 24px 0px 0px !important;\n  gap: 50px !important;\n  border: 0px 0px 1px 0px !important;\n  opacity: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bulkUploadNavButton": `Home_bulkUploadNavButton__hb7wC`,
	"addNewFpoBtn": `Home_addNewFpoBtn__oDyIW`,
	"textField": `Home_textField__uMnuD`,
	"titleHead": `Home_titleHead__r-5FZ`,
	"subHead": `Home_subHead__ymla+`,
	"css-nftsw0-MuiButtonBase-root-MuiTab-root": `Home_css-nftsw0-MuiButtonBase-root-MuiTab-root__M8DpN`,
	"Mui-selecte": `Home_Mui-selecte__OcW1p`,
	"SelectFpo": `Home_SelectFpo__H0H0n`,
	"programOfficer": `Home_programOfficer__CmqQF`,
	"lastUpdate": `Home_lastUpdate__nqZ6D`,
	"buttonStyle": `Home_buttonStyle__eGXze`,
	"boxStyle": `Home_boxStyle__t1-P4`
};
export default ___CSS_LOADER_EXPORT___;
